<template>
  <div style="width: 100%">
    <div class="search-choose-tip">标签:</div>
    <div style="display: flex">
      <div
        class="search-choose-tag"
        :class="
          tagOpenStatus ? 'search-choose-tag_close' : 'search-choose-tag_open'
        "
      >
        <span
          class="search-tag-item search-content-tag-item"
          :class="!tag.disabled ? 'active' : ''"
          v-for="(tag, index) in cTags"
          :key="index"
          @click="clickTag(tag)"
          >{{ tag.name }}</span
        >
      </div>
      <!-- <div class="search-choose-button" @click="tagOpenStatus = !tagOpenStatus">
        <span class="search-expand" type="setting">展开</span>
        <a-icon style="color: red" :type="tagOpenStatus ? 'down' : 'up'" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "tagList",
  props: {
    tags: {
      type: Array,
    },
  },
  data() {
    return {
      tagOpenStatus: true,
      chooseTag: [],
      currentTag: undefined,
      cTags:[],
    };
  },
  watch:{
    tags(newVal,oldVal){
      this.cTags = newVal;
    }
  },
  mounted(){

  },
  methods: {
    clickTag(tag) {
      let self = this;
      if (self.currentTag == undefined || self.currentTag == tag.id) {
        //是否存在已选的标签，已选标签是否为当前点击的标签
        self.tags.forEach((item) => {
          if (tag.id == item.id) {
            item.disabled = !item.disabled;
          }
        });
        self.currentTag = self.currentTag == undefined ? tag.id : undefined;
      } else {
        //已选标签不是当前点击标签
        self.tags.forEach((item) => {
          if (tag.id == item.id || self.currentTag == item.id) {
            item.disabled = !item.disabled;
          }
        });
        self.currentTag = tag.id;
      }
      self.$emit("tagFilter", self.currentTag);
    },
  },
};
</script>

<style lang="less" scoped>
.search-choose-tip {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  margin-right: 30px;
  float: left;
  width: 50px;
  margin-top: 20px;
}
.search-choose-tip-desc {
  margin-left: 10px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  margin-right: 30px;
}

.search-tag-item {
  padding: 5px 10px;
  margin: 0 10px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  display: inline-block;
  box-sizing: border-box;
  cursor: pointer;
}

.search-content-tag-item {
  margin-top: 15px;
  float: left;
  cursor: pointer;
  // line-height: 50px;
}

.active {
  background-color: #fd4734;
  color: #fff;
  border-color: #fd4734;
}
.search-choose-bottom {
  height: 50px;
  line-height: 50px;
  display: flex;
  .search-choose-tab-item {
    height: 50px;
    width: 100px;
    line-height: 50px;
  }
  .item-active {
    color: #f44336;
  }
  .add-project {
    background-color: #fd4734;
    color: #fff;
    position: absolute;
    right: 260px;
  }
}

.search-expand {
  color: #fd4734;
  margin-right: 5px;
}
.search-choose-button {
  // float: left;
  width: 120px;
  margin-top: 20px;
  cursor: pointer;
  user-select: none;
}
.search-choose-tag {
  overflow: hidden;
  // width: 1250px;
  padding-bottom: 20px;
  float: left;
  transition: height 0.5s;
}
.search-choose-tag_close {
  height: 60px;
}

.search-choose-tag_open {
  // height: 200px;
}
</style>